module.exports = __webpack_public_path__ + "img/Cober2-2.475683dc.jpg";